import styled from 'styled-components';

export const StyledDropdownGraphFilterWrapper = styled.div`
  position: 'absolute' !important;
  background-color: transparent !important;
  font-size: 15px;
  margin: 5px 10px 1px 10px;

  .e-input-group.e-ddl .e-input,
  .e-input-group.e-control-wrapper.e-ddl input.e-dropdownlist {
    text-indent: 4px !important;
    font-size: 12px !important;
  }



  .e-list-item {
    color: black !important;
  }

  cursor: pointer !important;

  .e-control.e-dropdownlist.e-lib.e-input,
  .e-input-group .e-control::placeholder {
    font-size: 18px !important;
    margin-left: 8px;
  }

  .e-input-group,
  .e-input-group.e-control-wrapper {
    /* border: 1px solid lightgray !important;
    border-radius: 6px !important;
    background-color: #fff !important; */
    border-bottom: none !important;
    transition: background-color 0.2s, border-color 0.2s;
  }

  .e-input-group:hover,
  .e-input-group.e-control-wrapper:hover {
    background-color: white !important;
  }
`;
